/**
 * Browser-safe Sanity client — no `server-only` imports.
 * Use this in client components and React hooks.
 * For server components / RSC data fetching use `sanityFetch` from `./client.ts`.
 */
import { getAppConfiguration } from '@utils/browserEnv';
import { createClient } from 'next-sanity';

const { projectId, dataset, studioUrl, apiVersion } = getAppConfiguration();

export const browserClient = createClient({
  projectId,
  dataset,
  apiVersion,
  useCdn: true,
  stega: {
    studioUrl,
    enabled: true,
    filter: () => true,
  },
});
